<template>
  <div>
    <span class="m-0" id="cart"></span>
    <div v-if="getTicketCart().qty > 0" class="chat-container w-100 position-relative">
      <template v-if="!show_xendit_cc_form">
        <!-- NAVBAR -->
        <div class=" position-relative">
          <div class="row no-gutters justify-content-center">
            <div class="fixed-top d-block nav-bottom">
              <div class="custom-container-fluid  px-0">
                <div class="row justify-content-center no-gutters">
                  <div class="col-xl-4 col-lg-4 col-md-6 col-sm-8 col-12 position-relative">
                    <div class="bg-green">
                      <div class="w-100">
                        <div class="row no-gutters">
                          <div class="col-8 py-14px">
                            <div class="w-100 pl-3">
                              <router-link :to="'/'+getMerchant().code+'/list'" class="d-inline-block align-middle">
                                <img src="../../assets/img/icon/back-white.png" width="20">
                              </router-link>
                              <p class="d-inline-block align-middle text-white heading-6 mb-0 ml-2">{{$t('ticket-cart.fill-in-details')}}</p>
                            </div>
                          </div>
                          <div class="col-4 text-right py-14px">
                            <router-link :to="'/'+getMerchant().code+'/ticket/order-history'">
                              <img src="../../assets/img/icon/history-white.png" class="mr-3" width="20">
                            </router-link>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
  
        <!-- HEADER -->
        <div class="container bg-green pb-3 pt-10">
          <div class="row slim-grid-row">
            <div class="col-4"></div>
            <div class="col-8 text-right">
              <p class="mb-0 text-green d-inline-block body-2-4 bg-white text-center circle-cart">1</p>
              <p class="mb-0 text-white d-inline-block body-3-3-3 ml-1">{{$t('ticket-cart.book')}}</p>
              <p class="mb-0 d-inline-block text-white opacity-45 ml-1 desh-cart">___</p>
              <p class="mb-0 text-green d-inline-block body-2-4 bg-white text-center circle-cart ml-1 bg-green-opacity">2</p>
              <p class="mb-0 text-white d-inline-block body-3-3-3 ml-1 opacity-45">{{$t('ticket-cart.pay')}}</p>
              <p class="mb-0 d-inline-block text-white opacity-45 ml-1 opacity-45 desh-cart">___</p>
            </div>
          </div>
          <div class="mt-3">
            <div class="bg-white rounded-10 py-3">
              <div v-if="merchant_category_name == 'ACTIVITIES'" class="px-3 pb-2">
                <img src="../../assets/img/icon/tickets.png" class="d-inline-block mr-1" width="15">
                <p class="mb-0 d-inline-block body-3-3-2">{{formatDate(this.getTicketCart().visit_date)}}</p>
              </div>
              <div class="px-3 bg-white">
                <div class="row slim-grid-row">
                  <div class="col-4">
                    <div class="w-100 pt-1" style="height:100%; min-height: 80px;max-height: 90px;">
                      <img :src="getMerchant().image_url" class="img-fit">
                    </div>
                  </div>
                  <div class="col-8">
                    <p class="mb-0 body-2-4 d-block text-truncate" style="color: #414955">{{getMerchant().name}} Tickets</p>
                    <img src="../../assets/img/icon/pin-green.png" width="12" class="d-inline-block align-top position-relative mt-1">
                    <p class="mb-0 body-3-3 text-light-bold d-inline-block align-top w-85">{{getMerchant().address}}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
  
        <!-- TICKET TRANSPORT -->
        <div class="container mb-5" v-if="merchant_category_name == 'TRANSPORT' && render_ticket_transport">
          <p class="mt-4 mb-3 px-2 color-black body-2">Trip Detail</p>
          <div class="bg-white rounded-10 box-shadow-light-aff">
            <div class="rounded-top-10">
              <div class="d-block p-3" :class="{'border-bottom-dashed': getTicketFilter().trip_type == 'return'}">
                <div class="d-block mb-0">
                  <div class="d-inline-block align-middle" style="max-width: 40%;">
                    <p class="mb-0 body-2-4 d-block text-truncate">{{departure_ticket.route_from.name}}</p>
                  </div>
                  <div class="d-inline-block align-middle mx-1">
                    <i class="iconsmind-Right body-2-4"></i>
                  </div>
                  <div class="d-inline-block align-middle" style="max-width: 40%;">
                    <p class="mb-0 body-2-4 d-block text-truncate">{{departure_ticket.route_to.name}}</p>
                  </div>
                </div>
                <div class="d-block mb-0">
                  <p class="mb-0 body-3-3-2 text-green d-inline-block align-middle">Departure</p>
                  <p class="mb-0 body-3 mx-1 d-inline-block align-middle">|</p>
                  <p class="mb-0 body-3-1 d-inline-block align-middle text-truncate" style="max-width: 70%;">{{getTicketCart().ticket_details[0].ticket.name}}</p>
                </div>
                <div class="d-block mb-1">
                  <div class="d-inline-block align-middle">
                    <p class="mb-0 body-3 float-left">{{formatTime(departure_ticket.route_from_time)}}</p>
                    <i class="iconsmind-Right body-3 float-left mx-1 mt-1"></i>
                    <p class="mb-0 body-3 float-left">{{formatTime(departure_ticket.route_to_time)}}</p>
                  </div>
                  <p class="mb-0 body-3 mx-1 d-inline-block align-middle">|</p>
                  <p class="mb-0 body-3 d-inline-block align-middle">{{formatDate(getTicketFilter().departure)}}</p>
                </div>
                <div class="d-block mb-0" v-if="departure_ticket.is_use_pick_up || departure_ticket.is_use_drop_off">
                  <div class="row no-gutters">
                    <div v-if="departure_ticket.is_use_pick_up  && checkDataExist(pick_up[0])" :class="{'col-6': departure_ticket.is_use_drop_off,'col-12': !departure_ticket.is_use_drop_off}">
                      <div class="d-block" :class="{'pr-1':departure_ticket.is_use_drop_off}">
                        <b-form-checkbox
                          v-model="pick_up[0].check_box"
                          :options="pick_up[0].data"
                          value="selected"
                          unchecked-value="unselected"
                          size="sm"
                        >
                          <p class="mb-0 body-3-3-2 text-green" style="margin-top: 1px;">Pick up?</p>
                        </b-form-checkbox>
                        <v-select v-if="pick_up[0].check_box == 'selected'" class="general-select-sm" :clearable="false" :options="pick_up[0].list" v-model="pick_up[0].selected">
                         <template v-slot:option="option">
                            <div>{{formatTime(option.departure_time)}} {{ option.transport_area__name }}</div>
                         </template>
                         <template v-slot:selected-option="option">
                            <div class="d-block text-truncate">{{formatTime(option.departure_time)}} {{ option.transport_area__name }}</div>
                          </template>
                        </v-select>
                      </div>
                    </div>
                    <div v-if="departure_ticket.is_use_drop_off  && checkDataExist(drop_off[0])" :class="{'col-6': departure_ticket.is_use_pick_up,'col-12': !departure_ticket.is_use_pick_up}">
                      <div class="d-block" :class="{'pl-1':departure_ticket.is_use_pick_up}">
                        <b-form-checkbox
                          v-model="drop_off[0].check_box"
                          :options="drop_off[0].data"
                          value="selected"
                          unchecked-value="unselected"
                          size="sm"
                        >
                          <p class="mb-0 body-3-3-2 text-green" style="margin-top: 1px;">Drop off?</p>
                        </b-form-checkbox>
                        <v-select v-if="drop_off[0].check_box == 'selected'" class="general-select-sm" :clearable="false" :options="drop_off[0].list" v-model="drop_off[0].selected">
                           <template v-slot:option="option">
                              <div>{{formatTime(option.departure_time)}} {{ option.transport_area__name }}</div>
                           </template>
                           <template v-slot:selected-option="option">
                              <div>{{formatTime(option.departure_time)}} {{ option.transport_area__name }}</div>
                            </template>
                        </v-select>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div v-if="getTicketFilter().trip_type == 'return'" class="d-block pt-2 px-3 pb-3">
                <div class="d-block mb-0">
                  <div class="d-inline-block align-middle" style="max-width: 40%;">
                    <p class="mb-0 body-2-4 d-block text-truncate">{{return_ticket.route_from.name}}</p>
                  </div>
                  <div class="d-inline-block align-middle mx-1">
                    <i class="iconsmind-Right body-2-4"></i>
                  </div>
                  <div class="d-inline-block align-middle" style="max-width: 40%;">
                    <p class="mb-0 body-2-4 d-block text-truncate">{{return_ticket.route_to.name}}</p>
                  </div>
                </div>
                <div class="d-block mb-0">
                  <p class="mb-0 body-3-3-2 text-green d-inline-block align-middle">Return</p>
                  <p class="mb-0 body-3 mx-1 d-inline-block align-middle">|</p>
                  <p class="mb-0 body-3-1 d-inline-block align-middle text-truncate" style="max-width: 70%;">{{getTicketCart().ticket_details[1].ticket.name}}</p>
                </div>
                <div class="d-block mb-1">
                  <div class="d-inline-block align-middle">
                    <p class="mb-0 body-3 float-left">{{formatTime(return_ticket.route_from_time)}}</p>
                    <i class="iconsmind-Right body-3 float-left mx-1 mt-1"></i>
                    <p class="mb-0 body-3 float-left">{{formatTime(return_ticket.route_to_time)}}</p>
                  </div>
                  <p class="mb-0 body-3 mx-1 d-inline-block align-middle">|</p>
                  <p class="mb-0 body-3 d-inline-block align-middle">{{formatDate(getTicketFilter().return)}}</p>
                </div>
                <div class="d-block mb-0" v-if="return_ticket.is_use_pick_up || return_ticket.is_use_drop_off">
                  <div class="row no-gutters">
                    <div v-if="return_ticket.is_use_pick_up  && checkDataExist(pick_up[1])" :class="{'col-6': return_ticket.is_use_drop_off,'col-12': !return_ticket.is_use_drop_off}">
                      <div class="d-block" :class="{'pr-1':return_ticket.is_use_drop_off}">
                        <b-form-checkbox
                          v-model="pick_up[1].check_box"
                          :options="pick_up[1].data"
                          value="selected"
                          unchecked-value="unselected"
                          size="sm"
                        >
                          <p class="mb-0 body-3-3-2 text-green" style="margin-top: 1px;">Pick up?</p>
                        </b-form-checkbox>
                        <v-select v-if="pick_up[1].check_box == 'selected'" class="general-select-sm" :clearable="false" :options="pick_up[1].list" v-model="pick_up[1].selected">
                         <template v-slot:option="option">
                            <div>{{formatTime(option.departure_time)}} {{ option.transport_area__name }}</div>
                         </template>
                         <template v-slot:selected-option="option">
                            <div class="d-block text-truncate">{{formatTime(option.departure_time)}} {{ option.transport_area__name }}</div>
                          </template>
                        </v-select>
                      </div>
                    </div>
                    <div v-if="return_ticket.is_use_drop_off  && checkDataExist(drop_off[1])" :class="{'col-6': return_ticket.is_use_pick_up,'col-12': !return_ticket.is_use_pick_up}">
                      <div class="d-block" :class="{'pl-1':return_ticket.is_use_pick_up}">
                        <b-form-checkbox
                          v-model="drop_off[1].check_box"
                          :options="drop_off[1].data"
                          value="selected"
                          unchecked-value="unselected"
                          size="sm"
                        >
                          <p class="mb-0 body-3-3-2 text-green" style="margin-top: 1px;">Drop off?</p>
                        </b-form-checkbox>
                        <v-select v-if="drop_off[1].check_box == 'selected'" class="general-select-sm" :clearable="false" :options="drop_off[1].list" v-model="drop_off[1].selected">
                           <template v-slot:option="option">
                              <div>{{formatTime(option.departure_time)}} {{ option.transport_area__name }}</div>
                           </template>
                           <template v-slot:selected-option="option">
                              <div>{{formatTime(option.departure_time)}} {{ option.transport_area__name }}</div>
                            </template>
                        </v-select>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
  
        <!-- PRODUCT LIST -->
        <div class="container mb-5">
          <p class="mt-4 mb-3 px-2 color-black body-2">{{$t('ticket-cart.additional-booking-details')}}</p>
          <div class="bg-white rounded-10 box-shadow-light-aff">
            <div class="px-3 pt-4 pb-1 rounded-top-10">
              <div class="d-block mb-3" v-for="ticket in getTicketCart().ticket_details">
                <!-- ticket -->
                <div class="row">
                  <div class="col-12">
                    <p class="mb-0 body-2-4">{{ticket.ticket.name}}</p>
                  </div>
                </div>
                <!-- variant -->
                <div class="row mb-1" v-for="variant in ticket.variant">
                  <!-- <div class="col-1">
                    <span class="dot-green"></span>
                  </div> -->
                  <div class="col-7">
                    <span class="dot-green ml-2 mr-1 d-inline-block align-middle"></span><p class="mb-0 body-2-2 pl-2 d-inline-block align-middle">{{variant.data.variant_name}} ({{variant.qty}}x)</p>
                  </div>
                  <div class="col-5 text-right">
                    <p class="mb-0 body-2-2">{{formatCurrency(variant.data.price_sell)}}</p>
                  </div>
                </div>
              </div>
            </div>
            <div class="py-4 px-3 bg-white rounded-bottom-10 border-top">
              <div class="row">
                <div class="col-7">
                  <p class="mb-0 body-1 color-black">{{$t('ticket-cart.total')}}</p>
                </div>
                <div class="col-5">
                  <p class="mb-0 sub-heading-1-2 color-black text-right">{{formatCurrency(getTicketCartSubTotal())}}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
  
        <!-- AUTH DATA -->
        <div class="px-3 mb-5" v-if="isNotLogin()">
          <router-link :to="'/'+getMerchant().code+'/login'">
            <div class="container my-3 pt-3 box-shadow-light-aff" style="background-color: #fafafc87" >
              <div class="row pb-3 slim-grid-row">
                <div class="col-2">
                  <img src="../../assets/img/icon/question.png" class="object-fit" width="45" height="45">
                </div>
                <div class="col-9">
                  <div class="ml-2">
                    <p class="mb-0 body-1-2">{{$t('restaurant.you-are-not-logged-in')}}</p>
                    <p class="mb-0 body-3">{{$t('restaurant.login-now-to-book-faster')}}</p>
                  </div>
                </div>
                <div class="col-1">
                  <img src="../../assets/img/icon/next.png" width="13" class="mt-3">
                </div>
              </div>
            </div>
          </router-link>
        </div>
  
        <!-- CONTACT FORM -->
        <div class="container mb-5">
          <p class="mt-4 mb-3 px-2 color-black body-2">{{$t('ticket-cart.contact-detail')}} <span style="color: #FF6144">*</span></p>
          <div class="bg-white rounded-10 box-shadow-light-aff">
            <div class="p-3" v-if="isNotLogin()">
              <div class="mb-3">
                <p class="mb-0 body-3-3-1">{{$t('ticket-cart.title')}} <span class="color-red">*</span></p>
                <v-select class="general-select" :clearable="false" :options="gender" v-model="contact.gender">
                </v-select>
              </div>
              <div class="mb-3 row">
                <div class="col-6">
                  <p class="mb-0 body-3-3-1">{{$t('ticket-cart.first-name')}} <span class="color-red">*</span></p>
                  <input type="text" class="form-control px-0 body-1-2 mb-1" v-model="contact.first_name" />
                </div>
                <div class="col-6">
                  <p class="mb-0 body-3-3-1">{{$t('ticket-cart.last-name')}}</p>
                  <input type="text" class="form-control px-0 body-1-2 mb-1" v-model="contact.last_name" />
                </div>
              </div>
              <div class="mb-3">
                <p class="mb-0 body-3-3-1">{{$t('ticket-cart.email')}} <span class="color-red">*</span></p>
                <input v-model="contact.email" type="email" class="form-control px-0 body-1-2 mb-1">
              </div>
              <div class="row my-4">
                <div class="col-4">
                  <p class="mb-0 body-3-3-1">Country Code <span v-if="is_payment_cc" class="color-red">*</span></p>
                </div>
                <div class="col-8">
                  <p class="mb-0 body-3-3-1">Mobile Number <span v-if="is_payment_cc" class="color-red">*</span></p>
                </div>
                <div class="col-4">
                  <v-select class="mt-2 general-select" :clearable="false" :options="country" v-model="contact.dial_code" label="dial_code">
                    <template #option="{ dial_code, code }">
                      <span class="body-2 mb-0">{{code}} </span>|<span class="body-2 text-color-dark"> {{dial_code}}</span>
                    </template>
                  </v-select>
                </div>
                <div class="col-8">
                  <input type="text" v-model="contact.phone" class="form-control mt-2 px-3 body-1-2 mb-1">
                </div>
              </div>
              <template v-if="is_payment_need_guest_address && is_payment_cc">
                <div class="w-100">
                  <p class="mb-0 body-3-3-1">Address <span class="color-red">*</span></p>
                  <textarea rows="2" class="form-control px-2 body-1 mb-1 mt-3" v-model="contact.address"></textarea>
                </div>
              </template>
            </div>
            <div class="p-3 bg-white rounded-10" v-else>
              <img src="../../assets/img/icon/correct.png" class="float-right position-relative" width="15">
              <p class="mb-1 sub-heading-1-1 color-black">{{contact.gender}}. {{contact.first_name}} {{contact.last_name}}</p>
              <p class="mb-0 body-2-2 text-light-bold">{{contact.email}} <span v-if="contact.phone != ''">| {{contact.phone}}</span></p>
            </div>
            <div class="bg-smoth-light px-3 py-3 rounded-bottom-10" v-if="merchant_category_name == 'ACTIVITIES'">
              <div class="form-check">
                <input class="form-check-input mt-2" type="radio" id="radio1" value="me" v-model="ticket_owner" />
                <label for="radio1" class="form-check-label body-2-2 text-light-bold mb-2">
                  I am the visitor
                </label>
                <br>
                <input class="form-check-input mt-2" type="radio" id="radio2" value="someone" v-model="ticket_owner" />
                <label for="radio2" class="form-check-label body-2-2 text-light-bold mb-2">
                  I’m Booking for someone else
                </label>
              </div>
            </div>
          </div>
        </div>
  
        <!-- CONTACT FORM TICKET TRANSPORT -->
        <div class="container mb-5" v-if="merchant_category_name == 'TRANSPORT' && render_ticket_transport">
          <p class="mt-4 mb-3 px-2 color-black body-2">Passenger Detail</p>
          <div class="bg-white rounded-10 box-shadow-light-aff px-3">
            <div class="row py-3 no-gutters" :class="{'border-bottom-dashed': index+1 != passenger.length}" v-for="(passenger_data,index) in passenger" @click="togglePassengerForm('show',passenger_data,index)"> 
              <div class="col-9">
                <p class="body-2-4 mb-0" v-if="passenger_data.name == ''">Passenger {{index+1}} : -</p>
                <template v-else>
                  <p class="body-3-3 mb-0 text-green">Passenger {{index+1}} :</p>
                  <p class="body-2-1 mb-0">{{passenger_data.name}}</p>
                </template>
              </div>
              <div class="col-3 text-right">
                <img class="align-top" src="../../assets/img/icon/edit-green.png" width="15">
              </div>
            </div>
          </div>
        </div>
  
        <!-- CONTACT FORM FOR SOMEONE ELSE -->
        <div class="container mb-5" v-if="ticket_owner == 'someone'">
          <p class="mt-4 mb-3 px-2 color-black body-2">{{$t('merchant.visitor-detail')}} <span style="color: #FF6144">*</span></p>
          <div class="bg-white rounded-10 box-shadow-light-aff">
            <div class="p-3">
              <div class="mb-3">
                <p class="mb-0 body-3-3-1">{{$t('ticket-cart.title')}} <span class="color-red">*</span></p>
                <v-select class="general-select" :clearable="false" :options="gender" v-model="visitor.gender">
                </v-select>
              </div>
              <div class="mb-3 row">
                <div class="col-6">
                  <p class="mb-0 body-3-3-1">{{$t('ticket-cart.first-name')}} <span class="color-red">*</span></p>
                  <input type="text" class="form-control px-0 body-1-2 mb-1" v-model="visitor.first_name" />
                </div>
                <div class="col-6">
                  <p class="mb-0 body-3-3-1">{{$t('ticket-cart.last-name')}}</p>
                  <input type="text" class="form-control px-0 body-1-2 mb-1" v-model="visitor.last_name" />
                </div>
              </div>
              <div class="mb-3">
                <p class="mb-0 body-3-3-1">{{$t('ticket-cart.email')}} <span class="color-red">*</span></p>
                <input v-model="visitor.email" type="email" class="form-control px-0 body-1-2 mb-1">
              </div>
            </div>
          </div>
        </div>
  
        <!-- PAYMENT METHOD LIST -->
        <div class="container mb-5">
          <p class="mt-4 mb-3 px-2 color-black body-2">{{$t('general.payment-method')}} <span style="color: #FF6144">*</span></p>
          <div class="bg-white rounded-10 box-shadow-light-aff">
            <loader v-if="payment_method.loader" />
            <template v-else>
              <div class="p-3 border-bottom-light cursor-pointer" @click="payment_method.new_selected = payment" v-for="(payment,index) in payment_method.new_list" :key="index">
                <div class="row">
                  <div class="col-10">
                    <label class="w-100" :for="payment.id">
                      <p class="mb-0 custom-transition" :class="{'body-3-3-2 text-green' : payment_method.new_selected.id == payment.id, 'body-2-4 text-light-bold' : payment_method.new_selected.id != payment.id}">{{payment.name}}</p>
                    </label>
                    <img v-if="payment_method.new_selected.id == payment.id" :src="payment.image_url" height="30" class="mb-2">
                  </div>
                  <div class="col-2">
                    <div class="dimention-24 rounded-circle ml-auto" :class="payment.id == payment_method.new_selected.id ? 'custom-radio-active' : 'border-semi-grey-3'">
                    </div>
                  </div>
                  <div class="col-12" v-if="payment_method.new_selected.id == payment.id && payment.payment_method == 'CREDIT_CARD'">
                    <div class="p-2 border radius-0" style="background-color: rgb(243, 251, 255);border-color: rgb(184, 202, 254) !important;">
                        <div class="row grid-slim-row">
                          <div class="col-12 no-ws">
                            <i class="simple-icon-info d-inline-block align-middle mr-2 text-12"></i>
                            <p class="mb-0 body-3-1 d-inline-block align-middle">Credit card memerlukan 3D Secure authentication</p>
                          </div>
                        </div>
                      </div>
                  </div>
                </div>
              </div>
            </template>
          </div>
        </div>

        <!-- PRICE DETAIL -->
        <div class="container mb-4" v-if="show_detail_price">
          <p class="mt-4 mb-3 px-2 color-black body-2">{{$t('hotel.concierge.price-detail')}}</p>
          <div class="bg-white rounded-10 box-shadow-light-aff">
            <div class="p-3 border-b-semi-grey-dashed">
              <div class="row no-gutters mb-2">
                <div class="col-6">
                  <p class="mb-0 body-2-1">{{$t('hotel.concierge.sub-total')}}</p>
                </div>
                <div class="col-6 text-right">
                  <p class="mb-0 body-2-1">{{$formatCurrency(getTicketCartSubTotal())}}</p>
                </div>
              </div>
              <div class="row no-gutters mt-2" v-if="payment_surcharge > 0">
                <div class="col-6">
                  <p class="mb-0 body-2-1">Payment Surcharge</p>
                </div>
                <div class="col-6 text-right">
                  <p class="mb-0 body-2-1">{{$formatCurrency(payment_surcharge)}}</p>
                </div>
              </div>
            </div>
            <div class="p-3">
              <div class="row no-gutters">
                <div class="col-5">
                  <p class="mb-0 body-1-2">{{$t('hotel.concierge.total')}}</p>
                </div>
                <div class="col-7 text-right">
                  <p class="mb-0 sub-heading-1-1">{{$formatCurrency(total_price)}}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
  
        <div class="p-3 d-block" v-if="!form_validation.valid && form_validation.message != ''">
          <div class="p-3 border radius-0" style="background-color: rgb(255, 243, 243);border-color: #feb8b8 !important;">
            <div class="row grid-slim-row">
              <div class="col-12 text-center">
                <p class="mb-0 body-3-1">{{form_validation.message}}</p>
              </div>
            </div>
          </div>
        </div>
        <div class="container mb-5 pb-5">
          <button class="bg-orange w-100 rounded-6 py-14px text-center border-0" @click="checkout()"> 
            <pulse-loader :loading="cart_loader" v-if="cart_loader"></pulse-loader>
            <p class="text-white body-15 mb-0" v-else>{{$t('ticket-cart.continue')}}</p>
          </button>
        </div>
      </template>
      <template v-else>
        <XenditInputCC
          :tx_payment="tx_payment"
          module_page="TICKET"
          @done="clearCart"
          @expired="goListPage">
        </XenditInputCC>
      </template>
    </div>
    
    <!-- EMPTY CART -->
    <div v-else class="bg-white text-center mt-8 mb-2 ">
      <img src="../../assets/img/icon/namaste.png" width="310">
      <p class="pt-3 heading-4 text-22 mb-2">{{$t('ticket-cart.empty-cart.title')}}</p>
      <p class="body-2 mb-4 w-75 mx-auto">{{$t('ticket-cart.empty-cart.message')}}</p>
      <div class="w-100 text-center">
        <button class="btn bg-green text-14 body-3-1 text-white px-3" @click="goTicketList()">{{$t('ticket-cart.empty-cart.button')}}</button>
        <button v-if="token().access != ''" class="btn bg-orange text-14 body-3-1 text-white px-3" @click="goOrderHistory()">{{$t('general.order-history')}}</button>
      </div>
    </div>
    <form :action="dkpayload.URL" method="post" id="dkpayform2018" name="dkpayform2018" ref="FormDKload">
        <input name="MALLID" type="hidden" v-model="dkpayload.MALLID" >
        <input name="BASKET" type="hidden" v-model="dkpayload.BASKET" >
        <input name="CHAINMERCHANT" type="hidden" v-model="dkpayload.CHAINMERCHANT" >
        <input name="AMOUNT" type="hidden" v-model="dkpayload.AMOUNT" >
        <input name="PURCHASEAMOUNT" type="hidden" v-model="dkpayload.PURCHASEAMOUNT" >
        <input name="TRANSIDMERCHANT" type="hidden" v-model="dkpayload.TRANSIDMERCHANT" >
        <input name="WORDS" type="hidden" v-model="dkpayload.WORDS" >
        <input name="CURRENCY" type="hidden" v-model="dkpayload.CURRENCY" >
        <input name="PURCHASECURRENCY" type="hidden" v-model="dkpayload.PURCHASECURRENCY" >
        <input name="COUNTRY" type="hidden" v-model="dkpayload.COUNTRY" >
        <input name="SESSIONID" type="hidden" v-model="dkpayload.SESSIONID" >
        <input name="REQUESTDATETIME" type="hidden" v-model="dkpayload.REQUESTDATETIME" >
        <input name="NAME" type="hidden" v-model="dkpayload.NAME" >
        <input name="EMAIL" type="hidden" v-model="dkpayload.EMAIL" >
        <input name="ADDRESS" type="hidden" v-model="dkpayload.ADDRESS" >
        <input name="MOBILEPHONE" type="hidden" v-model="dkpayload.MOBILEPHONE" >
    </form>
    <passenger-form v-if="passenger_form.show" :data="passenger_form.data" :index="passenger_form.index" @close="togglePassengerForm()" @save="savePassangerForm"></passenger-form>
    <warning-box 
      v-if="warning_transport" 
      @yes="goListPage"
      title="Return not selected"
      body="Please select return ticket to proceed to the cart page."
      btn_primary="Back">  
    </warning-box>
  </div>
</template>
<script>

  import {mapGetters, mapActions} from "vuex";
  import {formatCurrency,formatDate,checkDataExist,paymentMethodConverter} from '@/utils/index.js'
  import {post,get} from '@/services/index.js';
  import country from "@/data/country"
  import axios from 'axios';
  import moment from 'moment';
  import Form from '../../base'
  import PassengerForm from '@/components/ticket/PassengerForm'
  import WarningBox from '@/components/general/WarningBox'
  import XenditInputCC from '@/components/hotel/be/XenditInputCC';
  const { email } = require("vuelidate/lib/validators");
  
  export default{
    components:{
      PassengerForm,
      WarningBox,
      XenditInputCC
    },
    data(){
      return{
        contact:{
          email: '',
          first_name: '',
          last_name: '',
          phone: '',
          gender: 'Mr',
          dial_code: {},
          address: ''
        },
        visitor:{
          email: '',
          first_name: '',
          last_name: '',
          gender: 'Mr',
        },
        ticket_owner: '',
        country:country,
        gender: ['Mr',"Mrs"],
        cart_loader: false,
        form_validation:{
          message: '',
          valid: false,
        },
        payment_method: {
          loader: true,
          list: [],
          selected: '',
          bpd:{},
          new_list: [],
          new_selected: {}
        },
        pick_up: [],
        drop_off: [],
        passenger: [],
        warning_transport: false,
        passenger_form:{
          show: false,
          index: 0,
          data: {}
        },
        is_doku_merchant_hosted: false,
        dkpayload : new Form({
            MALLID : '',
            BASKET : '',
            CHAINMERCHANT : '',
            AMOUNT : '',
            PURCHASEAMOUNT : '',
            TRANSIDMERCHANT : '',
            WORDS : '',
            REQUESTDATETIME : '',
            CURRENCY : '',
            PURCHASECURRENCY : '',
            SESSIONID : '',
            NAME : '',
            EMAIL : '',
            ADDRESS : '',
            COUNTRY : '',
            URL : '',
        }),
        show_xendit_cc_form: false,
        tx_payment: {}
      }
    },
    computed:{
      is_contact_email(){
        return (this.$v.contact.email.$invalid == true) ? true : false
      },
      is_visitor_email(){
        return (this.$v.visitor.email.$invalid == true) ? true : false
      },
      is_payment_cc(){
        return this.payment_method.new_selected.payment_method && this.payment_method.new_selected.payment_method == 'CREDIT_CARD' ? true : false
      },
      is_payment_need_guest_address(){
        if(this.payment_method.new_selected.payment_method){
          return this.payment_method.new_selected.bank_name == 'DOKU' && this.payment_method.new_selected.pg_mode == 'MERCHANT_HOSTED'
        }else{ 
          return false
        }
      },
      departure_ticket(){
        if(this.getMerchant().merchant_category_name == 'TRANSPORT'){
          return this.getTicketCart().ticket_details[0].variant[0].data
        }else{
          return ''
        }
      },
      return_ticket(){
        if(this.getMerchant().merchant_category_name == 'TRANSPORT'){
          if(this.getTicketFilter().trip_type == 'return' && this.getTicketCart().ticket_details.length > 1){
            return this.getTicketCart().ticket_details[1].variant[0].data
          }else{
            return ''
          } 
        }else{
          return ''
        }
      },
      merchant_category_name(){
        return this.getMerchant().merchant_category_name
      },
      render_ticket_transport(){
        if(this.getMerchant().merchant_category_name == 'TRANSPORT' && this.getTicketFilter().trip_type == 'return' && this.getTicketCart().ticket_details.length == 1){
          return false
        }else{ 
          return true
        }
      },
      payment_surcharge(){
				let total = 0

				if(this.payment_method.new_selected.id){
					if(this.payment_method.new_selected.surcharge_type == 'PERCENT'){
						total = (this.getTicketCartSubTotal()/100)*this.payment_method.new_selected.surcharge_value
					}else{
						total = this.payment_method.new_selected.surcharge_value
					}

          if(this.payment_method.new_selected.bank_name == 'XENDIT' && this.payment_method.new_selected.payment_method == 'CREDIT_CARD') {
            total = Math.ceil(total)
          }
				}

				return total
			},
      total_price(){
      	return Math.round(this.getTicketCartSubTotal()+this.payment_surcharge)
      },
      show_detail_price(){
        let return_data = this.payment_method.new_list.some(x=>x.surcharge_value > 0)
        return return_data
      }
    },
    watch:{
      ticket_owner(){
        this.ticketSetOwnerCart(this.ticket_owner)
      }
    },
    validations: {
      contact: {
        email:{ 
          email
        },
      },
      visitor: {
        email:{ 
          email
        },
      }
    },
    mounted(){
      document.getElementById('cart').scrollIntoView({
          behavior: 'smooth'
      });
      this.ticket_owner = this.getTicketCart().ticket_owner
      if(this.merchant_category_name == 'TRANSPORT'){
        if(this.getTicketFilter().trip_type == 'return' && this.getTicketCart().ticket_details.length == 1){
          this.warning_transport = true
        }else{
          this.checkPickDrop()

          let passenger_loop = this.getTicketCart().qty
          if(this.getTicketFilter().trip_type == 'return') passenger_loop = passenger_loop/2

          for(let i = 0 ; i < passenger_loop;i++){
            let data = {
              name: '',
              date_of_birth: '',
              nationality: {} 
            }
            this.passenger.push(data)
          }
        }
      }
      if (!this.isNotLogin()) {
        this.getUserProfile();
      }else{
        this.contact.dial_code = this.country.find(x => x.code == 'ID')
      }
      if (Object.keys(this.getMerchant()).length > 0 && this.getTicketCart().qty > 0) {
        this.getPaymentList();
      }
    },
    methods:{
      ...mapGetters([
        'getTicketCart',
        'getMerchant',
        'getCurrentUser',
        'getTicketCartSubTotal',
        'token',
        'isNotLogin',
        'getTicketFilter']),
      ...mapActions([
        'setUser',
        'ticketSetOwnerCart',
        'ticketResetItemCart',
        'ticketSetPaymentDoku']),
      formatCurrency(value){
        return formatCurrency(value);
      },
      formatDate(date){
        return formatDate(date);
      },
      formatTime(time){
        return moment(time,'HH:mm:ss').format("HH:mm")
      },
      formatDuration(start,end,as){
        let start_formatted = moment(start,"HH:mm:ss")
        let end_formatted = moment(end,"HH:mm:ss")
        if(as == 'H'){
          return moment.duration(end_formatted.diff(start_formatted)).hours()
        }else{
          return moment.duration(end_formatted.diff(start_formatted)).minutes() 
        }
      },
      checkDataExist(data){
        return checkDataExist(data);
      },
      paymentMethodConverter(payment){
        return paymentMethodConverter(payment)
      },
      goTicketList(){
        this.$router.push({
          path: '/'+this.getMerchant().code+'/list'
        })
      },
      goOrderHistory(){
        this.$router.push({
          path: '/'+this.getMerchant().code+'/ticket/order-history'
        })
      },
      formValidation(){
        return new Promise((success)=>{
          // contact validation
          if (this.contact.gender == '') {

            this.form_validation.valid = false
            this.form_validation.message = 'Please select title in contact detail form'
            success(false)

          }else if (this.contact.first_name == ''){

            this.form_validation.valid = false
            this.form_validation.message = 'Please input first name in contact detail form'
            success(false)

          }else if (this.contact.email == ''){

            this.form_validation.valid = false
            this.form_validation.message = 'Please input email in contact detail form'
            success(false)

          }else if(this.is_contact_email){

            this.form_validation.valid = false
            this.form_validation.message = 'Please input a valid email'
            success(false)

          }else if(this.is_payment_cc){

            if (this.contact.phone == '') {
              this.form_validation.valid = false

              if(this.isNotLogin()){
                this.form_validation.message = 'Please input phone number in contact detail form'
              }else{
                this.form_validation.message = 'Please complete your phone number data in edit profile'
              }

              success(false)
            }else if(this.is_payment_need_guest_address && this.contact.address == ''){
              this.form_validation.valid = false

              if(this.isNotLogin()){
                this.form_validation.message = 'Please input address in contact detail form'
              }else{
                this.form_validation.message = 'Please complete your address data in edit profile'
              }

              success(false)
            }else{
              this.form_validation.valid = true
              this.form_validation.message = ''
              success(true)
            }

          } 

          else if(this.ticket_owner == 'someone'){

            // visitor validation
            if (this.visitor.gender == '') {

              this.form_validation.valid = false
              this.form_validation.message = 'Please select title in visitor detail form'
              success(false)

            }else if (this.visitor.first_name == ''){

              this.form_validation.valid = false
              this.form_validation.message = 'Please input first name in visitor detail form'
              success(false)

            }else if (this.visitor.email == ''){

              this.form_validation.valid = false
              this.form_validation.message = 'Please input email in visitor detail form'
              success(false)

            }else if(this.is_visitor_email){

              this.form_validation.valid = false
              this.form_validation.message = 'Please input a valid email'
              success(false)

            }

            else{
              this.form_validation.valid = true
              this.form_validation.message = ''
              success(true)
            }

          } 

          else if(!this.payment_method.new_selected.id){
            this.form_validation.valid = false
            this.form_validation.message = 'Please select payment method'
            success(false)
          }

          else{
            this.form_validation.valid = true
            this.form_validation.message = ''
            success(true)
          }      
        })
      },
      checkout(){
        this.cart_loader = true
        this.form_validation.valid = true
        this.form_validation.message = ''
        this.formValidation().then(validForm=>{
          if (!validForm) {
            this.cart_loader = false
          }else{
            let params = {
              merchant_id: this.getMerchant().id,
              visit_date: moment(this.getTicketCart().visit_date).format("YYYY-MM-DD"),
              visitor_details: {
                first_name: this.contact.first_name,
                last_name: this.contact.last_name,
                phone_number: "",
                email: this.contact.email,
                gender: this.contact.gender,
                address: ''
              },
              customer_details:{
                first_name: this.contact.first_name,
                last_name: this.contact.last_name,
                phone_number: this.contact.phone,
                email: this.contact.email,
                gender: this.contact.gender,
                address: this.contact.address
              },
              ticket_details: [],
              payment_details: {
                payment_gateway: "doku"
              },
              promo_code: ''
            }

            if (this.ticket_owner == 'someone') {
              params.visitor_details = {
                first_name: this.visitor.first_name,
                last_name: this.visitor.last_name,
                email: this.visitor.email,
                gender: this.visitor.gender,
                phone_number: '',
                address: ''
              }
            }

            for(let i = 0 ; i < this.getTicketCart().ticket_details.length ; i++){
              for(let j = 0 ; j < this.getTicketCart().ticket_details[i].variant.length ; j++){
                params.ticket_details.push({
                  id: this.getTicketCart().ticket_details[i].variant[j].data.id,
                  qty: this.getTicketCart().ticket_details[i].variant[j].qty
                })
              }
            }

            post("CORE","tx-ticket-inquiry",params).then(response=>{
              let res = response.data
              if (res.success) {
                this.processPayment(res.data.tx_order_id,res.data.payment_details);
              }else{
                this.cart_loader = false
              }
            })
          }
        })
      },
      processPayment(id,payment_list){
        let data_payment = {
          id: this.payment_method.new_selected.id,
          payment_method: this.payment_method.new_selected.payment_method,
          bank_name: this.payment_method.new_selected.bank_name,
          payment_channel: this.payment_method.new_selected.payment_method
        }

        if(this.payment_method.new_selected.payment_method == 'VIRTUAL_ACCOUNT'){
          if(this.payment_method.new_selected.bank_name == 'BPD_BALI'){
            data_payment.payment_channel = "VA_BPD_BALI"
          }else if(this.payment_method.new_selected.bank_name == 'DOKU'){
            data_payment.payment_channel = "VA_ATM_BERSAMA"
          }
        }
        
        post("CORE","tx-ticket-payment",{
          tx_order_id:id,
          payment_details: data_payment
        }).then(response=>{
          let res = response.data
          if (res.success) {
            if(this.payment_method.new_selected.bank_name == 'XENDIT' && this.payment_method.new_selected.payment_method == 'CREDIT_CARD'){
              this.tx_payment = res.payment
              this.show_xendit_cc_form = true
            }else{
              this.clearCart()
              if(this.payment_method.new_selected.bank_name == 'DOKU' && this.payment_method.new_selected.payment_method == 'CREDIT_CARD'){
                if(this.payment_method.new_selected.pg_mode == 'PG_HOSTED'){
                  this.dkpayload.MALLID = res.payment.form.MALLID;
                  this.dkpayload.BASKET = res.payment.form.BASKET;
                  this.dkpayload.CHAINMERCHANT = res.payment.form.CHAINMERCHANT;
                  this.dkpayload.AMOUNT = res.payment.form.AMOUNT;
                  this.dkpayload.PURCHASEAMOUNT = res.payment.form.PURCHASEAMOUNT;
                  this.dkpayload.TRANSIDMERCHANT = res.payment.form.TRANSIDMERCHANT;
                  this.dkpayload.WORDS = res.payment.form.WORDS;
                  this.dkpayload.REQUESTDATETIME = res.payment.form.REQUESTDATETIME;
                  this.dkpayload.CURRENCY = res.payment.form.CURRENCY;
                  this.dkpayload.PURCHASECURRENCY = res.payment.form.PURCHASECURRENCY;
                  this.dkpayload.SESSIONID = res.payment.form.SESSIONID;
                  this.dkpayload.NAME = res.payment.form.NAME;
                  this.dkpayload.EMAIL = res.payment.form.EMAIL;
                  this.dkpayload.ADDRESS = res.payment.form.ADDRESS;
                  this.dkpayload.MOBILEPHONE = res.payment.form.MOBILEPHONE;
                  this.dkpayload.COUNTRY = res.payment.form.COUNTRY;
                  this.dkpayload.URL = res.payment.payment_url;
                  this.$nextTick(() => {
                      this.$refs.FormDKload.submit();
                  });
                }else{
                  this.ticketSetPaymentDoku({
                    type: 'CREDIT_CARD',
                    data: res.payment
                  })
                  this.$router.push({
                    path: '/'+this.getMerchant().code+'/payment/'+res.tx_order_id
                  })
                }
              }else if(this.payment_method.new_selected.bank_name == 'JOKUL_DOKU' && this.payment_method.new_selected.payment_method == 'CREDIT_CARD'){
                loadJokulCheckout(res.payment.url)
              }else{
                this.$router.push({
                  path: '/'+this.getMerchant().code+'/payment/'+res.tx_order_id
                })
              }
            }
            
          }else{
            this.form_validation.valid = false
            this.form_validation.message = res.message
          }
          this.cart_loader = false
        })
      },
      getUserProfile(){
        get("BASE","auth/profile").then(response=>{
          let res = response.data.user
          this.contact.first_name = res.first_name
          this.contact.last_name = res.last_name
          this.contact.email = res.email
          this.contact.phone = res.phone
          this.contact.address = res.address
        })
      },
      getPaymentList(){
        this.payment_method.loader = true
        get("CORE","merchant-payment/"+this.getMerchant().id).then(response=>{
          let res = response.data
          if (res.success) {
            this.payment_method.list = res.data
            this.payment_method.new_list = res.data
            let is_jokul_exist = res.data.some(x=>x.bank_name == 'JOKUL_DOKU' && x.payment_method == 'CREDIT_CARD')
            if(is_jokul_exist){
              this.$appendJokulScript()
            }
          }else{
            console.log(res.message)
          }
          this.payment_method.loader = false
        })
      },
      checkPickDrop(){
        let ticket = this.getTicketCart().ticket_details;
        for(let i = 0; i < ticket.length; i++){
          if(ticket[i].variant[0].data.is_use_pick_up || ticket[i].variant[0].data.is_use_drop_off){
            this.getPickDropData(ticket[i].ticket.id).then(res=>{
              if(res != false){
                if(ticket[i].variant[0].data.is_use_pick_up){
                  let pick_up = {
                    check_box: 'unselected',
                    data: ['selected','unselected'],
                    list: res.PICK_UP,
                    selected: {}
                  }
                  this.pick_up.push(pick_up)                }
                if(ticket[i].variant[0].data.is_use_drop_off){
                  let drop_off = {
                    check_box: 'unselected',
                    data: ['selected','unselected'],
                    list: res.DROP_OFF,
                    selected: {}
                  }
                  this.drop_off.push(drop_off)
                }
              }
            })
          }
        }
      },
      getPickDropData(product_id){
        return new Promise((success)=>{
          get("CORE","transport-area",{
            product_id: product_id
          }).then(response=>{
            let res = response.data
            if(res.success){
              success(res.data)
            }else{
              success(false)
            }
          })
        })
      },
      togglePassengerForm(type='hide',data,index){
        if(type == 'show'){
          this.passenger_form.data = data
          this.passenger_form.index = index
          this.passenger_form.show = true
        }else{
          this.passenger_form.show = false
          this.passenger_form.data = {}
          this.passenger_form.index = 0
        }
      },
      savePassangerForm(data){
        console.log("test :", data)
        this.passenger[data.index] = data.data
        this.togglePassengerForm()
      },
      goListPage(){
        this.$router.push({
          path: '/'+this.getMerchant().code+'/list'
        })
      },
      clearCart(){
        this.ticketResetItemCart("with_date")
      }
    }
  }
</script>
<style scoped>
  .w-85{
    width: 85% !important;
  }

  .circle-cart {
    border-radius: 100%;
    width: 26px;
    height: 26px;
    padding: 3px 6px;
  }

  .opacity-45 {
    color: #b5cc92 !important;
  }

  .bg-green-opacity {
    background-color: #b5cc92 !important
  }

  .desh-cart {
    position: relative;
    top: -5px;
  }

  .text-light-bold {
    color: #414955A6 !important;
  }

  .bg-smoth-light {
    background-color: #FAFAFC;
  }

  .rounded-bottom-10 {
    border-bottom-left-radius: 10px;
    border-bottom-right-radius: 10px;
  }

  .rounded-top-10 {
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
  }

  .color-black {
    color: #000 !important
  }

  .color-red{
    color:red;
  }

  input {
    border: none;
    border-radius: 0px !important;
    border-bottom: 1px solid #0000001A;
  }
  .dot-green{
    display: block;
    height: 5px;
    width: 5px;
    border-radius: 50%;
    background: #79a33a !important;
  }
  input:focus{
    border-top: none !important;
    border-left: none !important;
    border-right: none !important;
    box-shadow: none !important;

  }
  .custom-transition{
    transition: 0.2s;
  }
  textarea{
    border: none;
    border-radius: 0px !important;
    border-bottom: 1px solid #0000001A;
  }

</style>



// WEBPACK FOOTER //
// src/pages/ticket/Cart.vue